// 缓冲mp3文件
export function downloadAudio(remoteHostList, remotePath, dest, timeout) {
  let loadAudio = (resolve, reject) => {
    let host = remoteHostList.shift()
    let src = `${location.protocol}//${host}${remotePath}`
    // console.log('[dynamic-preload]downloadAudio src=====', src)
    let $t = null
    let audioObj = new Audio(src)

    audioObj.addEventListener("canplay", () => {
      audioObj = null
      $t && clearTimeout($t)
      resolve(src)
    })

    audioObj.addEventListener("error", () => {
      audioObj = null
      $t && clearTimeout($t)
      if (remoteHostList.length) {
        // 加载报错切换加载来源
        loadAudio(resolve, reject)
      } else {
        reject(new Error("loadFail.0"))
      }
    })

    $t = setTimeout(() => {
      audioObj = null
      $t && clearTimeout($t)
      if (remoteHostList.length) {
        loadAudio(resolve, reject)
      } else {
        reject(new Error("loadFail.1"))
      }
    }, timeout)
  }
  return new Promise((resolve, reject) => {
    loadAudio(resolve, reject)
  })
}
